var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedClass)?_c('div',{staticClass:"swatcher-bulma"},_vm._l((_vm.bgClasses),function(bgClass){return _c('span',{key:bgClass,class:[
      'swatcher-bulma__item',
      ("has-background-" + bgClass),
      bgClass === _vm.selectedClass ? 'swatcher-bulma__selected' : '' ],on:{"click":function($event){return _vm.onSelectBg(bgClass)}}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }